import { h, render } from 'preact'; // eslint-disable-line no-unused-vars
import { ProductCard, ProductEmptyState } from './cards/Product';

export function renderProductCards(wrapper, lots, projectName) {
    document.getElementById(wrapper).innerHTML = '';
    var products = [];

    lots.forEach(lot => {
        if (lot.status.toLowerCase() !== "sold") {
            lot.products.forEach(product => {
                product.lotItem = lot;
                products.push(product);                
            });
        }        
    });

    if (products.length == 0) {
        const productEmptyState = <ProductEmptyState project = { projectName } />;
        render(productEmptyState, document.getElementById(wrapper));
    }
    else {
        // Sort the products by price
        products.sort((a, b) => a.price - b.price);
        products.forEach(product => {
            const productCards = <ProductCard { ...product } lot = { product.lotItem } />
            render(productCards, document.getElementById(wrapper));
        });
    }
}